import React, { useCallback, useState } from 'react';
import { Calendar } from 'lucide-react';
import DateSelector from '../components/DateSelector';
import { useField, useFormikContext } from 'formik';
import dayjs from 'dayjs';

export default function DateRangeField({
    name,
    setIsDateSelectorOpen,
    isDateSelectorOpen,
}) {
    const [field] = useField(name);
    const { setFieldValue } = useFormikContext();

    const toggleDateSelector = () => {
        setIsDateSelectorOpen(!isDateSelectorOpen);
    };

    const handleDateSelect = useCallback(
        selectedDates => {
            const newValue = selectedDates.selection;
            setFieldValue(name, { date: newValue });
        },
        [name]
    );

    return (
        <div className="relative flex-1 w-full ">
            <div
                className="flex border lg:border-l-0 items-center p-4 whitespace-nowrap border-r border-gray-200 cursor-pointer rounded-full lg:rounded-none "
                onClick={toggleDateSelector}
            >
                <Calendar
                    className="text-gray-400 mr-2 flex-shrink-0"
                    size={20}
                />
                <span className="text-gray-700">
                    {field?.value?.date?.startDate
                        ? `${dayjs(field?.value?.date?.startDate).format(
                              'DD.MM.YYYY'
                          )} -
                        ${dayjs(field.value.date.endDate).format('DD.MM.YYYY')}`
                        : 'Reisedaten auswählen'}
                </span>
            </div>

            <DateSelector
                isOpen={isDateSelectorOpen}
                onClose={() => setIsDateSelectorOpen(false)}
                onDateSelect={handleDateSelect}
                dateValue={field?.value?.date}
            />
        </div>
    );
}
